import React, { PureComponent } from 'react';
import * as api from '../../../../services/api';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import InactiveBranchesPage from '../../../presenters/admins/InactiveBranchesPage/InactiveBranchesPage';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

class InactiveBranchesContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      branches: []
    };

    this.loadState = this.loadState.bind(this);
  }

  componentDidMount() {
    this.loadState();
  }

  loadState() {
    this.setState(
      {
        loading: true
      },
      () => {
        api.branches
          .getInactiveOnly()
          .then((response) => {
            this.setState({
              branches: response.data.content,
              loading: false
            });
          })
          .catch((err) => {
            console.error('error fetching branches: ', err.message);
            this.setState({
              loading: false
            });
          });
      }
    );
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <InactiveBranchesPage inactiveBranches={this.state.branches} />
    );
  }
}

export default injectIntl(withRouter(InactiveBranchesContainer));
